module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-8bb8ae8b.png";